export default __webpack_public_path__ + "static/media/SG-Green-0001.d27a1d60.png";